import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../../../Apiurl";
import umanizzaDataSenzaSecondi from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaSecondi";

function StatiPrestashop({ idSped }) {
  const [loading, setLoading] = useState(false);
  const [listaStati, setListaStati] = useState([]);

  const { user, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    const fetchStatiPrestashop = async () => {
      setLoading(true);

      const nuoviParams = new URLSearchParams({
        idSped,
      });
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const response = await axios.get(
        apiUrl + "/logistica/ordine/getStatiPrestashopOrdine?" + nuoviParams,
        config
      );

      setListaStati(response.data || []);
      setLoading(false);
    };

    if (!token || !idSped) {
      return;
    }

    fetchStatiPrestashop();
  }, [token, idSped]);

  if (loading) {
    return <div>caricamento...</div>;
  }

  if (!listaStati || listaStati.length === 0) {
    return (
      <div className="sezioneConScroll h-100 w-100 pa3">
        <div className="br3 ba b--light-gray pa3">
          Nessun cambio stato Prestashop registrato per questo idPS.
        </div>
      </div>
    );
  }

  return (
    <div className="sezioneConScroll h-100 w-100 pa3">
      {listaStati.map((stato) => (
        <div
          key={stato.id}
          className="mb3 pa3 br3"
          style={{
            backgroundColor: "#eef4ff",
            borderTop: "3px solid #001B44",
          }}
        >
          <div className="flex flex-wrap justify-between items-center">
            <div className="b f4">
              {stato.statoPrestashopLabel} ({stato.statoPrestashopId})
            </div>
            <div className="f6">
              {umanizzaDataSenzaSecondi(stato.dataEvento)}
            </div>
          </div>

          <div className="mt2">
            Impostato su Prestashop per l&apos;ordine PS {stato.idPS}.
          </div>

          {stato.idSpedCausale && (
            <div className="mt2">
              Motivo: spedizione ID <strong>{stato.idSpedCausale}</strong>
              {stato.partenzaDaCausale ? (
                <> con partenza da <strong>{stato.partenzaDaCausale}</strong></>
              ) : null}
              {stato.statoSpedizioneCausale ? (
                <>
                  {" "}
                  in stato <strong>{stato.statoSpedizioneCausale}</strong>
                </>
              ) : null}
              {stato.corriereCausale ? (
                <>
                  {" "}
                  e corriere <strong>{stato.corriereCausale}</strong>
                </>
              ) : null}
              .
            </div>
          )}

          {stato.statoPrestashopSpiegazione && (
            <div className="mt2">{stato.statoPrestashopSpiegazione}</div>
          )}

          <div className="mt3 flex flex-wrap">
            <div className="mr3 mb2">
              <small className="ttu b">Esito</small>
              <div>{stato.esito || "-"}</div>
            </div>
            <div className="mr3 mb2">
              <small className="ttu b">Feedback Tembo</small>
              <div>{stato.temboOutcome || "-"}</div>
            </div>
            <div className="mr3 mb2">
              <small className="ttu b">Hold fino a</small>
              <div>
                {stato.holdUntil ? umanizzaDataSenzaSecondi(stato.holdUntil) : "-"}
              </div>
            </div>
            <div className="mr3 mb2">
              <small className="ttu b">Stato Domino</small>
              <div>{stato.statoDomino || "-"}</div>
            </div>
            <div className="mr3 mb2">
              <small className="ttu b">Ordine splittato</small>
              <div>{stato.ordineSplittato ? "SI" : "NO"}</div>
            </div>
          </div>

          {stato.temboResponseItem && (
            <div className="mt2">
              <small className="ttu b">Dettaglio response</small>
              <pre className="mt1 pa2 br2" style={{ backgroundColor: "#f8fbff" }}>
                {JSON.stringify(stato.temboResponseItem, null, 2)}
              </pre>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default StatiPrestashop;
